const metrics = () => {
  /* Установка метрики по клику на кнопку телеграмма */
  (() => {
    const buttonsTelegram = document.querySelectorAll('.TelegramClickSZ');
    
    buttonsTelegram.forEach(button => {
      button.addEventListener('click', () => {
        ym(100783979,'reachGoal','bot');
      })
    })
  })(); 
};

export default metrics;
